import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
//Local Modules
import { useStyles } from './styles'
import Tooltip from '@material-ui/core/Tooltip'
import SimpleDropdown from 'components/common/SimpleDropdown/SimpleDropdown'

const SimpleAutocomplete = ({ label, tooltipText, options, filterOptions, error, onSelect, initialValue }) => {
    // const [field, meta] = useField(props)
    const [inputText, setInputText] = useState(initialValue)
    const [open, setOpen] = useState(false)
    const classes = useStyles()

    const handleInputChange = ({ target: { value } }) => {
        open || setOpen(true)
        setInputText(value)
        filterOptions(value)
    }

    const selectOption = option => () => {
        setInputText(option)
        onSelect(option)
        setOpen(false)
    }

    const handleRequestClose = () => {
        setOpen(false)
        selectOption('')()
    }

    const shownOptions = options.length > 0 ? options : [inputText]

    return (
        <div className={classes.formCtrl}>
            <div className={classes.labelContainer}>
                <label className={classes.label}>{label}</label>
                {tooltipText && (
                    <Tooltip title={tooltipText} placement="left">
                        <div>
                            <FontAwesomeIcon className={classes.info} icon={faInfoCircle} />
                        </div>
                    </Tooltip>
                )}
            </div>
            <div className={classes.inputContainer}>
                <input className={classes.input} type="text" value={inputText} onChange={handleInputChange} />
                <SimpleDropdown isOpen={open} onRequestClose={handleRequestClose}>
                    <ul className={classes.optionContainer}>
                        {Array.isArray(shownOptions) &&
                            shownOptions.map((o, i) => (
                                <li onClick={selectOption(o)} className={classes.option} key={i}>
                                    {o}
                                </li>
                            ))}
                    </ul>
                </SimpleDropdown>
            </div>
            {error ? <div className={classes.error}>{error}</div> : null}
        </div>
    )
}

export default SimpleAutocomplete
